import { IconButton, MenuItem } from "@mui/material"
import AnchorMenu from "../../../genericGrid/utility/AnchorMenu"
import Text from "../../../genericComponents/Text"
import { MoreVertOutlined } from "@mui/icons-material"
import { useState } from "react"
import DownloadCSV from "../../../helpers/DownloadCSV"
import downloadData from "../../../helpers/Download"
import downloadSvg from "../../../helpers/downloadSVG"

const DownloadMenu=({data,type,graph})=>{
    const [anchorEl, setAnchorEl] = useState()
    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const downloadCSV=()=>{
        DownloadCSV({data,fileName:type});        
    }
    const downloadSVG=()=>{
        downloadSvg({ref:graph,fileName:type});        
    }
    const handleClose = () => {        
        setAnchorEl(null)
    }
    return (<><AnchorMenu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={e => { handleClose(); e.stopPropagation() }}
        >
            <MenuItem
                onClick={e => {
                    e.stopPropagation()
                    downloadCSV();
                    handleClose()
                }}>
                <Text text={"Export as CSV"} />
            </MenuItem>
            <MenuItem
                onClick={e => {                    
                    e.stopPropagation()
                    downloadSVG();
                    handleClose()
                }}>
                <Text text={"Export as PNG"} />
            </MenuItem>
        </AnchorMenu>
        <IconButton onClick={handleClick} aria-label="settings">
        <MoreVertOutlined />
    </IconButton></>)
}
export default DownloadMenu;